import { useState } from "react";

import { Turn as Hamburger } from "hamburger-react";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { HashLink as Link } from "react-router-hash-link";
import { useNavigate, useLocation } from "react-router-dom";

import { LogoLettersBlack } from "../../../assets/images";
import { navbarTiles } from "../../../utils/arrays";
import { isTabletOrMobileSize } from "../../../utils/queries";
import { LOGIN } from "../../../utils/strings";
import { HOME } from "../../../utils/routes";
import CustomModal from "../../../components/CustomModal";
import DashboardModal from "../../../components/DashboardModal";
import Login from "../../auth/Login";
import {
  Container,
  LeftContainer,
  RightContainer,
  LogoStyle,
  NavbarTitle,
  TitleTab,
  LoginButton,
  SignUpButton,
  ButtonContainer,
  LogoContainer,
  NavLinksContainer,
  MobileMenuOverlay,
  MobileMenuItem,
  MobileMenuDivider,
  MobileMenuAction,
} from "./styles";

interface NavbarProps {
  dashboardScreen: boolean;
  checkoutScreen: boolean;
  darkText?: boolean;
}

const Navbar = ({ dashboardScreen, checkoutScreen, darkText = false }: NavbarProps) => {
  const isTabletOrMobile = useMediaQuery({ query: isTabletOrMobileSize });
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const { gymOwnerLoggedIn, memberLoggedIn, loggedIn } = useSelector(
    (state: RootState) => state.auth
  );

  const navigate = useNavigate();
  const location = useLocation();

  const handleOpenModal = () => { setMobileMenuOpen(false); setShowModal(!showModal); };
  const handleOpenSettings = () => setShowSettingsModal(!showSettingsModal);
  const handleSignUp = () => { setMobileMenuOpen(false); navigate("/signup"); };

  const isActive = (route?: string) => {
    if (!route) return false;
    if (route === "/") return location.pathname === "/";
    return location.pathname === route;
  };

  const userDashboard = memberLoggedIn || gymOwnerLoggedIn;
  const desktopNotLoginUser = !loggedIn && !isTabletOrMobile;
  const showHamburger = isTabletOrMobile && !loggedIn && !checkoutScreen;

  return (
    <>
      <Container>
        <LeftContainer>
          <LogoContainer>
            <LogoContainer>
              {loggedIn ? (
                <LogoStyle
                  src={LogoLettersBlack}
                  alt="logo"
                  dashboardscreen={dashboardScreen ? "true" : "false"}
                  darktext={darkText ? "true" : "false"}
                />
              ) : (
                <Link to={`${HOME}#hero`} smooth style={{ textDecoration: "none" }}>
                  <LogoStyle
                    src={LogoLettersBlack}
                    alt="logo"
                    dashboardscreen={dashboardScreen ? "true" : "false"}
                    darktext={darkText ? "true" : "false"}
                  />
                </Link>
              )}
            </LogoContainer>
          </LogoContainer>
        </LeftContainer>

        {!isTabletOrMobile && !gymOwnerLoggedIn && !memberLoggedIn && !checkoutScreen && (
          <NavLinksContainer>
            {navbarTiles.map((tile) => {
              const active = isActive(tile.route);

              if (tile.route) {
                return (
                  <TitleTab
                    key={tile.route}
                    onClick={() => navigate(tile.route!)}
                    style={{ cursor: "pointer" }}
                  >
                    <NavbarTitle active={active} darktext={darkText ? "true" : "false"}>{tile.name}</NavbarTitle>
                  </TitleTab>
                );
              }

              if (tile.id) {
                return (
                  <Link key={tile.id} to={tile.id} smooth style={{ textDecoration: "none" }}>
                    <TitleTab>
                      <NavbarTitle darktext={darkText ? "true" : "false"}>{tile.name}</NavbarTitle>
                    </TitleTab>
                  </Link>
                );
              }

              return null;
            })}
          </NavLinksContainer>
        )}

        <RightContainer>
          {(userDashboard || desktopNotLoginUser || checkoutScreen) && (
            <ButtonContainer>
              {!loggedIn && !checkoutScreen && location.pathname !== "/signup" && (
                <SignUpButton onClick={handleSignUp}>Sign Up</SignUpButton>
              )}
              <LoginButton darktext={darkText ? "true" : "false"} onClick={loggedIn ? handleOpenSettings : handleOpenModal}>
                {loggedIn ? "Settings" : LOGIN}
              </LoginButton>
            </ButtonContainer>
          )}
          {showHamburger && (
            <Hamburger
              toggled={mobileMenuOpen}
              toggle={setMobileMenuOpen}
              size={22}
              color={darkText ? "#000000" : "#ffffff"}
              rounded
            />
          )}
        </RightContainer>

        {mobileMenuOpen && (
          <MobileMenuOverlay>
            {navbarTiles.map((tile) => {
              if (tile.route) {
                return (
                  <MobileMenuItem
                    key={tile.route}
                    onClick={() => { setMobileMenuOpen(false); navigate(tile.route!); }}
                  >
                    {tile.name}
                  </MobileMenuItem>
                );
              }
              if (tile.id) {
                return (
                  <Link
                    key={tile.id}
                    to={tile.id}
                    smooth
                    style={{ textDecoration: "none" }}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <MobileMenuItem>{tile.name}</MobileMenuItem>
                  </Link>
                );
              }
              return null;
            })}
            <MobileMenuDivider />
            <MobileMenuAction variant="outline" onClick={handleOpenModal}>Log in</MobileMenuAction>
            <MobileMenuAction variant="solid" onClick={handleSignUp}>Sign up</MobileMenuAction>
          </MobileMenuOverlay>
        )}

        <CustomModal
          showModal={showModal}
          onClose={() => setShowModal(false)}
          content={<Login />}
          backgroundColor="#ffffff"
          closeColor="#555555"
        />
        <CustomModal
          showModal={showSettingsModal}
          onClose={handleOpenSettings}
          content={<DashboardModal />}
          width="420px"
          padding="10px 0px 0px 0px"
          backgroundColor="#ffffff"
          closeColor="#555555"
        />
      </Container>
    </>
  );
};

export default Navbar;
